<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'shared.modals.user-create.title' | translate }}
    </h5>
  </div>
  <form [formGroup]="userForm" (ngSubmit)="submitUser()">
    <div class="modal-body">
      <div class="modal-form-row">
        <input type="text" class="input small-input" id="account-modal-form-username" name="account-modal-form-username"
               [placeholder]="'shared.modals.account.form.information.controls.username.placeholder' | translate"
               formControlName="userName"
        >
        <select formControlName="admin">
          <option [value]="false">Support</option>
          <option [value]="true">Administrator</option>
        </select>
      </div>
      <div class="modal-form-row red"
           *ngIf="userForm && userForm.dirty && userForm.controls.userName.errors as error">
        <ng-container *ngIf="(error | keyvalue) as keyValue">
          <ng-container *ngIf="keyValue[0] as currentError" [ngSwitch]="currentError.key">
            <ng-container *ngSwitchCase="'required'"></ng-container>
            <ng-container *ngSwitchDefault>{{ 'errors.form.' + currentError.key | translate }}</ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="modal-form-row">
        <input type="password" class="input small-input" id="account-modal-form-password"
               name="account-modal-form-password"
               [placeholder]="'shared.modals.account.form.password.controls.password.placeholder' | translate"
               formControlName="password"
        >
        <input type="password" class="input small-input" id="account-modal-form-repeat" name="account-modal-form-repeat"
               [placeholder]="'shared.modals.account.form.password.controls.repeat.placeholder' | translate"
               formControlName="repeat"
        >
      </div>
      <div class="modal-form-row red"
           *ngIf="userForm && userForm.dirty && userForm.controls.password.errors as error">
        <ng-container *ngIf="(error | keyvalue) as keyValue">
          <ng-container *ngIf="keyValue[0] as currentError" [ngSwitch]="currentError.key">
            <ng-container *ngSwitchCase="'required'"></ng-container>
            <ng-container *ngSwitchDefault>{{ 'errors.form.' + currentError.key | translate }}</ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="modal-form-row">
        <input type="text" class="input small-input" id="account-modal-form-firstname"
               name="account-modal-form-firstname"
               [placeholder]="'shared.modals.account.form.information.controls.firstname.placeholder' | translate"
               formControlName="firstName"
        >
        <input type="text" class="input small-input" id="account-modal-form-lastname" name="account-modal-form-lastname"
               [placeholder]="'shared.modals.account.form.information.controls.lastname.placeholder' | translate"
               formControlName="lastName"
        >
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="closeModal()" ngbAutofocus>
        {{ 'shared.modals.user-create.form.buttons.close' | translate }}
      </button>
      <button class="btn btn-success" type="submit" [disabled]="!userForm.valid">
        {{ 'shared.modals.user-create.form.buttons.create' | translate }}
      </button>
    </div>
  </form>
</div>
